import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/src/stylus/app.styl'

Vue.use(Vuetify, {
  iconfont: 'md',
  theme: {
    primary: "#009688",
    secondary: "#5bb2a9",
    accent: "#009688",
    error: "#c62828",
    info: "#009688"
  }
});
